export default "__VITE_ASSET__acQQfJz___"